import React from "react";
import { Button } from "antd";
import { MenuOutlined, MessageOutlined } from "@ant-design/icons";

import useMediaQuery from "hooks/useMediaQuery";
import { ASK_NARROW } from "pages/ask/askBreakpoints";
import { useAskShell } from "pages/ask/AskShellContext";
import { threadMeta } from "pages/ask/threadGroups";
import "pages/ask/askMobileBar.scss";

/**
 * Ask's compact top bar on a phone: app menu, the open chat's name, and the chats drawer.
 *
 * The product name lives in the Ask rail; this bar names the conversation. One control tall --
 * never a flex sibling that stretches beside the transcript.
 */
export default function AskMobileBar({
    title = "New chat",
    sources = "",
    at = "",
    pendingTitle = false,
    showChats = true,
    loading = false,
    away = false,
}) {
    const isNarrow = useMediaQuery(ASK_NARROW);
    const { openAppNav, openChats } = useAskShell();
    const when = threadMeta(at);

    if (!isNarrow) return null;

    return (
        <header className={`ask-mobile-bar${away ? " is-away" : ""}`}>
            <Button
                type="text"
                className="ask-mobile-bar__btn"
                aria-label="Open app menu"
                icon={<MenuOutlined />}
                onClick={openAppNav}
            />
            <div className="ask-mobile-bar__title">
                {loading ? (
                    <span className="ask-mobile-bar__name is-pending">Loading…</span>
                ) : (
                    <>
                        <span className={`ask-mobile-bar__name${pendingTitle ? " is-pending" : ""}`} title={title}>
                            {title || "New chat"}
                        </span>
                        {sources ? (
                            <span className="ask-mobile-bar__sources" title={sources}>
                                {sources}
                            </span>
                        ) : null}
                        {when.label ? (
                            <time className="ask-mobile-bar__when" dateTime={at || undefined} title={when.exact}>
                                {when.label}
                            </time>
                        ) : null}
                    </>
                )}
            </div>
            {showChats ? (
                <Button
                    type="text"
                    className="ask-mobile-bar__btn ask-rail__toolbar"
                    aria-label="Chats and sources"
                    icon={<MessageOutlined />}
                    onClick={openChats}
                />
            ) : (
                <span className="ask-mobile-bar__btn ask-mobile-bar__btn--spacer" aria-hidden="true" />
            )}
        </header>
    );
}
